<template>
  <div class="p-4 border-b border-inky-depths-300 border-dashed" @click="handleMenuItemPressed">
    <div class="flex items-center justify-between">
      <p :class="{ 'text-ocean-surge-300': route.name === menuItem?.routeName }">{{ menuItem.title }}</p>
      <Icon
        v-if="menuItem?.subItems"
        name="arrow-alt-down"
        class="w-2 h-2 fill-wave-crest-50 transition-all duration-500"
        :class="{ 'rotate-180': subItemsExpanded }" />
    </div>
    <!-- Expanded section -->
    <Transition>
      <div v-if="subItemsExpanded && menuItem?.subItems?.length" class="pl-4 flex flex-col py-4 gap-4">
        <NuxtLink
          v-for="(subItem, index) in menuItem.subItems"
          :key="index"
          :to="{ name: subItem.routeName }"
          :class="{ 'text-ocean-surge-300': route.name === subItem?.routeName }"
          >{{ subItem.title }}</NuxtLink
        >
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import type { MobileMenuItem } from '~/types'

const props = defineProps<{
  menuItem: MobileMenuItem
}>()

const route = useRoute()
const router = useRouter()

// Auto expanded if instantiated and route exists in subItems and route is active
const subItemsExpanded = ref<boolean>(props.menuItem?.subItems?.some((subItem) => subItem.routeName === route.name) || false)

const handleMenuItemPressed = () => {
  if (props.menuItem.routeName) {
    router.push({ name: props.menuItem.routeName })
  }
  if (props.menuItem.subItems) {
    subItemsExpanded.value = !subItemsExpanded.value
  }
}
</script>
